import { Component, type ErrorInfo, type ReactNode } from 'react';

interface CampaignErrorBoundaryProps {
  children: ReactNode;
  resetKey?: string;
}

interface CampaignErrorBoundaryState {
  hasError: boolean;
}

export class CampaignErrorBoundary extends Component<CampaignErrorBoundaryProps, CampaignErrorBoundaryState> {
  constructor(props: CampaignErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): CampaignErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(_error: Error, _errorInfo: ErrorInfo): void {}

  componentDidUpdate(prevProps: CampaignErrorBoundaryProps): void {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}
